module.exports = __webpack_public_path__ + "img/VNT.5c8546d2.jpg";